import { render } from "./F2Pagination.vue?vue&type=template&id=1f3f3e8f&scoped=true&ts=true"
import script from "./F2Pagination.vue?vue&type=script&lang=ts"
export * from "./F2Pagination.vue?vue&type=script&lang=ts"

import "./F2Pagination.vue?vue&type=style&index=0&id=1f3f3e8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3f3e8f"]])

export default __exports__